/**
 * Normalizes text for search purposes by removing special characters,
 * converting to lowercase, and trimming whitespace.
 *
 * This function handles cases like:
 * - "O'Leary" -> "oleary"
 * - "Dr. Smith" -> "dr smith"
 * - "Jean-Pierre" -> "jeanpierre"
 * - "O`Connor" -> "oconnor"
 * - "Smith & Sons" -> "smith sons"
 *
 * @param text - The text to normalize
 * @returns Normalized text suitable for search comparison
 */
export default function normalizeTextForSearch(text: string): string {
  return (
    text
      .toLowerCase()
      .trim()
      // Remove apostrophes, backticks, hyphens, periods, and ampersands
      .replace(/[''`\-.&]/g, '')
      // Remove extra whitespace
      .replace(/\s+/g, ' ')
  );
}
